import type { GolfCard } from '~/core/types/golf-card.type'

export function useGolfCard(golf: GolfCard) {
  const services = computed(() => golf.services && golf.services.length > 2
    ? `${golf.services.filter((_, k) => k < 3).join(', ')}, ...`
    : `${golf.services?.filter((_, k) => k < 3).join(', ') ?? ''}`)

  const rate = computed(() => golf.rating_count && golf.rating_count >= 1000
    ? (golf.rating_count / 1000).toFixed(1).replace(/\.0$/, '') + 'k'
    : golf.rating_count?.toString())

  return {
    services,
    rate,
  }
}
